export const UserActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    FETCH_COLLECTION_START:"FETCH_COLLECTION_START",
    FETCH_COLLECTION_SUCCESS:"FETCH_COLLECTION_SUCCESS",
    FETCH_COLLECTION_FAILURE:"FETCH_COLLECTION_FAILURE"
}